import {
  VISITOR_COLUMN_NAME,
  type GetOrgVisitorsParams,
} from "./types/common.type";

export const DEFAULT_VISITORS_QUERY: GetOrgVisitorsParams = {
  page: 1,
  limit: 50,
  q: "",
};

export const VISITORS_SERIAL_CHECKBOX_COLUMN = "serial";

export enum VisitorsRightSidebarTabKeys {
  ACTIVITY = "activity",
  COMPANY_INFO = "company-info",
  TECH_STACK = "tech-stack",
}

export const visitorColFieldToPropertyNameMap = {
  visitor_company_domain: VISITOR_COLUMN_NAME.COMPANY,
  visitor_company_intent: VISITOR_COLUMN_NAME.INTENT_SCORE,
  visitor_last_active: VISITOR_COLUMN_NAME.LAST_VISITED_AT,
  visitor_count: VISITOR_COLUMN_NAME.VISITOR_COUNT,
  visitor_visit_count: VISITOR_COLUMN_NAME.SESSION_COUNT,
  company_type: VISITOR_COLUMN_NAME.COMPANY_TYPE,
};

export const VISITOR_COLUMN_DEFAULT_WIDTH = {
  default: 230,
  small: 140,
};

export const INTENT_SCORE_DROPDOWN_OPTIONS = [
  { value: "high", label: "High", order: 1 },
  { value: "medium", label: "Medium", order: 2 },
  { value: "low", label: "Low", order: 3 },
];

export const CUSTOM_FIELDS_VISITOR_FILTERS = {
  custom_visited_pages: "custom_visited_pages",
  custom_first_visit_date: "custom_first_visit_date",
};

export const CUSTOM_FIELDS_VISITOR_FILTERS_LABEL = {
  [CUSTOM_FIELDS_VISITOR_FILTERS.custom_visited_pages]: "Visited pages",
  [CUSTOM_FIELDS_VISITOR_FILTERS.custom_first_visit_date]: "First visit date",
};
